module.exports = __webpack_public_path__ + "static/media/coin.65bde6d4.png";